import ProductCard, { ProductCards } from "./ProductCard";
import IconExteriorHouse from "ui/icons/IconExteriorHouse";
import IconPlan from "ui/icons/IconPlan";
import IconUsersFour from "ui/icons/IconUsersFour";

## Basic Usage

<ProductCard
  title="Projects"
  subtitle="Manage your design projects"
  href="#projects"
/>

---

## With Icon

<ProductCard
  icon={<IconExteriorHouse />}
  title="Floor Plans"
  subtitle="View and edit floor plan designs"
  href="#floor-plans"
/>

---

## Custom CTA Text

<ProductCard
  icon={<IconUsersFour />}
  title="Team Members"
  subtitle="Invite and manage team access"
  href="#team"
  ctaText="View Team"
/>

---

## Sizes

<div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
  <ProductCard
    icon={<IconExteriorHouse />}
    title="Small Card"
    subtitle="Default small size"
    href="#small"
    size="small"
  />
  <ProductCard
    icon={<IconExteriorHouse />}
    title="Large Card"
    subtitle="Larger card variant"
    href="#large"
    size="large"
  />
</div>

---

## Product Cards Container

Use `ProductCards` wrapper for grid layout:

<ProductCards>
  <ProductCard
    icon={<IconExteriorHouse />}
    title="Designs"
    subtitle="Create and manage designs"
    href="#designs"
  />
  <ProductCard
    icon={<IconPlan />}
    title="Floor Plans"
    subtitle="View floor plan layouts"
    href="#floor-plans"
  />
  <ProductCard
    icon={<IconUsersFour />}
    title="Team"
    subtitle="Manage team members"
    href="#team"
    ctaText="Manage Team"
  />
</ProductCards>

---

## Disabled

<ProductCards>
  <ProductCard
    title="Available"
    subtitle="This card is clickable"
    href="#available"
    ctaText="Launch"
  />
  <ProductCard
    title="Unavailable"
    subtitle="No data for this feature"
    href="#unavailable"
    ctaText="Launch"
    disabled
  />
</ProductCards>
